__turbopack_context__.v({
  "close-icon": "EmailForwardingModal-module-scss-module__wdvmMG__close-icon",
  "dialog-wrapper": "EmailForwardingModal-module-scss-module__wdvmMG__dialog-wrapper",
  "headline": "EmailForwardingModal-module-scss-module__wdvmMG__headline",
  "hero": "EmailForwardingModal-module-scss-module__wdvmMG__hero",
  "label-input": "EmailForwardingModal-module-scss-module__wdvmMG__label-input",
  "modal-title": "EmailForwardingModal-module-scss-module__wdvmMG__modal-title",
  "modal-title-success": "EmailForwardingModal-module-scss-module__wdvmMG__modal-title-success",
  "nevermind-link": "EmailForwardingModal-module-scss-module__wdvmMG__nevermind-link",
  "paste-email-mask-container": "EmailForwardingModal-module-scss-module__wdvmMG__paste-email-mask-container",
  "underlay": "EmailForwardingModal-module-scss-module__wdvmMG__underlay",
});
